import React from 'react'

import {ButtonPrimary, Buttons} from '../../ui-kit/Button'
import Animate from '../../ui-kit/Animate'

import {ButtonBlock, TextBlock, Disclaimer, Heading, Paragraph, Item, Content} from '../../styles'

var Text3 = ({onNext, page, pages}) => {

  return (
    <Content>
      <TextBlock>
        <Animate duration=".8s" delay=".3s">
          <Disclaimer>
            Página {page} de {pages}
          </Disclaimer>
          <Heading>
            Ou seja
          </Heading>
        </Animate>

        <Animate duration=".8s" delay="1s">
          <Paragraph>
            <Animate duration=".8s" delay="1s">
              <Item>Cada um só se preocupa com a sua área.</Item>
            </Animate>
            <Animate duration=".8s" delay="1.5s">
              <Item>Ninguém foca em resolver o problema como um todo.</Item>
            </Animate>
            <Animate duration=".8s" delay="2s">
              <Item>Ninguém se conversa.</Item>
            </Animate>
          </Paragraph>
        </Animate>
      </TextBlock>

      <Animate duration=".3s" delay="3s">
        <ButtonBlock>
          <Buttons>
            <ButtonPrimary onClick={onNext}>
              Próximo
            </ButtonPrimary>
          </Buttons>
        </ButtonBlock>
      </Animate>
    </Content>
  )

}

export default Text3